import { Truck, Eye, Sun, Home, Sprout, Ruler } from "lucide-react";

const tiles = [
  {
    icon: Truck,
    title: "Transport & traffic",
    body: "Access via the R350 and L8184, approached from the M6 and N65. No oversized loads — panels arrive by standard HGV. A Traffic Management Plan will set haul routes, safety procedures and road-cleaning measures to keep disruption to a minimum.",
    span: "md:col-span-7",
  },
  {
    icon: Eye,
    title: "Landscape & visual",
    body: "A Landscape & Visual Impact Assessment is underway. The enclosed nature of the fields already screens much of the project; new hedgerows will be planted and existing ones strengthened.",
    span: "md:col-span-5",
  },
  {
    icon: Sun,
    title: "Glint & glare",
    body: "Specialist modelling identifies any potential glint and glare effects along roads and at homes. Where needed, panel orientation and screening will be adjusted to remove the effect.",
    span: "md:col-span-5",
  },
  {
    icon: Home,
    title: "Residential amenity",
    body: "Panels are set back from homes and screened by hedgerows. The site is very quiet in operation.",
    span: "md:col-span-7",
  },
  {
    icon: Sprout,
    title: "Biodiversity & habitats",
    body: "Mature hedgerow, trees, small woodland, wet drains, peatland and Annex I Molinia meadows have all been identified and avoided in the layout. A Biodiversity Enhancement Management Plan (BEMP) will protect and improve these areas.",
    span: "md:col-span-8",
  },
  {
    icon: Ruler,
    title: "Key design factors",
    body: "Generous set-backs from homes and roads, avoidance of valuable habitats, flood-risk mitigation, row spacing for vegetation, set-backs from hedgerows, drainage that mirrors existing greenfield run-off, and avoidance of registered heritage sites.",
    span: "md:col-span-4",
  },
];

export default function InformationGrid() {
  return (
    <section id="information" className="bg-[#F9F8F6]" data-testid="information-grid-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-4">The full picture</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              How the project will be built — and how it sits with its neighbours.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85">
              The boxes below summarise each assessment we are carrying out. We
              are deliberately publishing this in plain language at the
              pre‑planning stage so the community can ask questions, raise
              concerns and help shape the final layout.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {tiles.map((t, i) => {
            const Ic = t.icon;
            return (
              <article
                key={i}
                data-testid={`info-tile-${i}`}
                className={`bg-white border border-[#E0DCD3] rounded-sm p-8 ${t.span} hover:shadow-sm transition-shadow`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-sm bg-[#F2EFE8] text-[#3A4B3A] border border-[#E0DCD3]">
                    <Ic className="h-4 w-4" strokeWidth={1.8} />
                  </span>
                  <h3 className="font-serif-display text-xl tracking-tight">{t.title}</h3>
                </div>
                <p className="text-[14.5px] leading-relaxed text-[#2A2B2A]/85">{t.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
